import React from 'react'
import PropTypes from 'prop-types'
import { getCookieConsentCategories } from '@client/utils/insertThirdPartyScripts'

function YelpPixel({ revenue, orderid, country }) {
  if (!getCookieConsentCategories(country)?.marketing) {
    return null
  }

  const urlString = `https://insight.adsrvr.org/track/pxl/?adv=oqj70ne&ct=0:gb2k7tx&fmt=3&v=${revenue}&orderid=${orderid}`
  return (
    <div style={{ display: 'none' }}>
      <img
        height={1}
        width={1}
        style={{ borderStyle: 'none' }}
        alt=""
        src={urlString}
        data-testid="yelp-pixel"
      />
    </div>
  )
}

YelpPixel.propTypes = {
  revenue: PropTypes.string.isRequired,
  orderid: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
}

export default YelpPixel
